import { render, staticRenderFns } from "./ContactPlugin.vue?vue&type=template&id=d9d936f8&scoped=true&"
import script from "./ContactPlugin.vue?vue&type=script&lang=js&"
export * from "./ContactPlugin.vue?vue&type=script&lang=js&"
import style0 from "./ContactPlugin.vue?vue&type=style&index=0&id=d9d936f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d936f8",
  null
  
)

export default component.exports